import React from 'react';
import RichTextBubbleFontFamilyPicker from './RichTextBubbleFontFamilyPicker';

/**
 * Choix d'une police parmi celles du thème, précédées de « Par défaut (X) » :
 * une valeur vide suit la police héritée `defaultFont`. Même sélecteur pour
 * le texte (section « Texte ») et pour les titres du thème.
 *
 * @param {{
 *   value: string | null, options: { label: string, value: string }[],
 *   defaultFont: string | null, onChange: (font: string | null) => void,
 * }} props Les autres props vont au dropdown.
 */
export default function ThemeFontFamilyPicker({ defaultFont, ...pickerProps }) {
  return (
    <RichTextBubbleFontFamilyPicker
      {...pickerProps}
      defaultOption={{
        label: defaultFont ? `Par défaut (${defaultFont})` : 'Par défaut',
        font: defaultFont,
      }}
      listLabel="Polices du thème"
    />
  );
}
